<template>
  <div
    class="collection-image"
    @click="triggerInputFile()"
    @drop.prevent="addDroppedFile"
    :style="getImageUrl() ? { background: `url(${getImageUrl()}) no-repeat center` } : undefined"
  >
    <div v-if="getImageUrl() && !disabled" class="remove-button" @click="handleRemoveImage($event)">
      <div class="remove-icon"></div>
    </div>

    <loader-static v-if="uploadingInProgress" :loading="true" :size="'20px'" :dark="true" class="image-upload-loader" />

    <div class="fake-file-input font-sans-regular" v-if="!getImageUrl() && !uploadingInProgress">Choose File</div>
    <input
      v-if="!getImageUrl()"
      ref="collectionImageInput"
      style="display: none"
      accept="image/jpeg,image/png"
      type="file"
      @change="onInputFileChange($event)"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
.collection-image {
  height: 104px;
  width: 91px;
  min-width: 91px;
  background: $color-grey;
  margin-right: 24px;
  position: relative;
  .remove-button {
    background: $secondaryGrey;
    border-radius: 2px;
    position: absolute;
    top: 8px;
    right: 8px;
    .remove-icon {
      width: 40px;
      height: 40px;
      background: url("~@/assets/img/icons/trash_icon.svg") no-repeat center;
    }
  }

  &:hover {
    cursor: pointer;
    .remove-icon {
      background: url("~@/assets/img/icons/trash_icon_active.svg") no-repeat center;
    }
  }

  .fake-file-input {
    position: absolute;
    background: #ededed;
    border-radius: 2px;
    border: 1px solid black;
    color: black;
    top: calc(50% - 10px);
    height: 20px;
    width: calc(100% - 4px);
    left: 2px;
    text-align: center;
    font-size: 14px;
  }

  .image-upload-loader {
    position: absolute;
    top: calc(50% - 10px);
    left: calc(50% - 10px);
  }
}
</style>

<script>
import { ImageService } from "@/services/image.service";

export default {
  props: {
    viewComponent: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    removeImage: {
      type: Function,
      default: () => null,
    },
    assignImageUrl: {
      type: Function,
      default: () => null,
    },
  },
  data: function () {
    return {
      uploadingInProgress: false,
    };
  },
  methods: {
    triggerInputFile,
    onInputFileChange,
    submitImage,
    addDroppedFile,
    getImageUrl,
    handleRemoveImage,
  },
};

function getImageUrl() {
  return this.viewComponent.info?.image_url;
}

function triggerInputFile() {
  if (this.getImageUrl() || this.uploadingInProgress) {
    return;
  }

  this.$refs.collectionImageInput?.click();
}

function onInputFileChange(event) {
  if (!event.target.files.length) {
    return;
  }

  const file = event.target.files[0];
  this.submitImage(file);
}

function addDroppedFile(event) {
  if (this.getImageUrl() || this.uploadingInProgress) {
    return;
  }

  const dataTransfer = event.dataTransfer,
    files = dataTransfer.files;
  this.submitImage(files[0]);
}

async function submitImage(image) {
  const reqBody = {
    crop_image: image,
    original_image: image,
    crop_data: {},
    ordinal: 1,
    extra_info: {},
  };

  try {
    this.uploadingInProgress = true;
    const { data } = await ImageService.uploadImage(reqBody);
    this.assignImageUrl(data.original_url);
  } catch (error) {
    console.error(error);
  } finally {
    this.uploadingInProgress = false;
  }
}

function handleRemoveImage(event) {
  event.stopPropagation();
  event.preventDefault();
  this.removeImage();
}
</script>
